export default __webpack_public_path__ + "static/SignUp-0744868f8f410da37696619d69f59004.webp";